<template>
    <div class="about">
        <!-- 顶部操作按钮 -->
        <div class="top-actions">
            <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
            <el-button type="default" size="small" icon="el-icon-download" @click="handleExportAll">导出</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>
            <div class="search-container">
                <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
                <el-button type="default" icon="el-icon-search" @click="showSearchFields = !showSearchFields"></el-button>
            </div>
        </div>

        <!-- 高级搜索 -->
        <div v-if="showSearchFields" class="advanced-search-fields">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="任务ID">
                            <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名">
                            <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="采集源">
                            <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <el-input v-model="searchForm.creationTime" placeholder="请输入创建时间"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-button type="default" @click="handleAdvancedSearch">提交</el-button>
        </div>

        <!-- 表格 -->
        <el-table ref="filterTable" :data="pagedData" :header-cell-style="{ color: '#606266', background: '#f5f7fa' }" style="width: 100%" stripe border @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="user_id" label="任务id" sortable width="180" column-key="date" :filters="[{ text: '2016-05-01', value: '2016-05-01' }, { text: '2016-05-02', value: '2016-05-02' }, { text: '2016-05-03', value: '2016-05-03' }, { text: '2016-05-04', value: '2016-05-04' }]" :filter-method="filterHandler"></el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="content" label="评论内容"></el-table-column>
            <el-table-column prop="sec_uid" label="评论ID"></el-table-column>
           <!--  <el-table-column prop="add_time" label="采集时间" :formatter="formatter"></el-table-column> -->
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    <el-button size="mini" type="primary" @click="handleCopyHomepage(scope.row)">复制主页</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="currentPage"
                :page-size="pgSize"
                :total="totalItems"
                @current-change="handlePageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { douyin_aweme_comments,
     douyin_aweme_comments2,
      douyin_aweme_comments3,
       douyin_aweme_comments4, 
       douyin_aweme_comments7, 
       douyin_aweme_comments8, 
       douyin_aweme_comments9, 
       douyin_aweme_comments10, 
       douyin_aweme_comments11, 
       douyin_aweme_comments12, 

       delete_douyin_aweme_comment } from '@/api/douyin';
import moment from 'moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    data() {
        return {
            currentPage: 1,
            pgSize: 50, // 每页显示 50 条
            idx: -1,
            editVisible: false,
            form: {},
            searchQuery: '',
            showSearchFields: false,
            searchForm: {
                taskId: '',
                taskName: '',
                collectionSource: '',
                creationTime: ''
            },
            selectedRows: [],
            tableData: [], // 原始数据
        }
    },
    computed: {
        filteredTableData() {
            return this.tableData.filter(data => {
                return Object.values(data).some(value => {
                    return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
                });
            });
        },
        pagedData() {
            const start = (this.currentPage - 1) * this.pgSize;
            const end = start + this.pgSize;
            return this.filteredTableData.slice(start, end);
        },
        totalItems() {
            return this.filteredTableData.length; // 分页总数基于筛选后的数据
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';
            const apiMap = {
                'admin': douyin_aweme_comments,
                'manager': douyin_aweme_comments2,
                'zhuzhu': douyin_aweme_comments3,
                'huolong': douyin_aweme_comments4,
                'buzhi': douyin_aweme_comments4,
                'ruiqi': douyin_aweme_comments4,
                'daolai': douyin_aweme_comments4,
                'yangguang': douyin_aweme_comments7,
                'jinlianan': douyin_aweme_comments8,
                'jinlianan2': douyin_aweme_comments9,
                'dianguang1': douyin_aweme_comments10,
                'dianguang2': douyin_aweme_comments11,
                'dianguang3': douyin_aweme_comments12,
                'demo': douyin_aweme_comments8,

            };
            return apiMap[userRole] || douyin_aweme_comments;
        },
        fetchData() {
            const api = this.getApiByRole();
            api().then(response => {
                this.tableData = response.data.map(item => ({
                    user_id: item.user_id,
                    nickname: item.nickname,
                    note: item.note_url,
                    content: item.content,
                    xhsid: item.nickname,
                    count: item.comment_count,
                    add_time: item.add_time,
                    sec_uid: item.sec_uid,
                }));
            }).catch(error => {
                console.error('获取数据时出错！', error);
            });
        },
        handleExportAll() {
            if (this.filteredTableData.length === 0) {
                this.$message.warning('没有可导出的数据！');
                return;
            }
            
            const dataToExport = this.filteredTableData.map(item => {
                const sec_uid = item.sec_uid;
                const homepageUrl = `https://www.douyin.com/user/${sec_uid}`;
                return {
                    "任务id": item.user_id,
                    "昵称": item.nickname,
                    "评论内容": item.content,
                    "评论ID": item.sec_uid,
                    "主页链接": homepageUrl
                };
            });
            
            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: "application/octet-stream" });
            saveAs(blob, '全部数据导出.xlsx');
            
            this.$message.success(`成功导出 ${dataToExport.length} 条数据`);
        },
        handleCopyHomepage(row) {
            const sec_uid = row.sec_uid;
            const homepageUrl = `https://www.douyin.com/user/${sec_uid}`;
            if (homepageUrl) {
                navigator.clipboard.writeText(homepageUrl).then(() => {
                    this.$message.success('主页链接已复制到剪贴板');
                }).catch(err => {
                    this.$message.error('无法复制主页链接');
                });
            } else {
                this.$message.warning('没有找到主页链接');
            }
        },
        handleAdvancedSearch() {
            const api = this.getApiByRole();
            api({
                taskId: this.searchForm.taskId,
                taskName: this.searchForm.taskName,
                collectionSource: this.searchForm.collectionSource,
                creationTime: this.searchForm.creationTime
            }).then(response => {
                this.tableData = response.data;
            }).catch(error => {
                console.error('高级搜索失败', error);
            });
            this.showSearchFields = false;
        },
        handleDeleteSelected() {
            const userIds = this.selectedRows.map(row => row.user_id);
            Promise.all(userIds.map(id => delete_douyin_aweme_comment(id)))
                .then(() => {
                    this.$message.success('删除成功');
                    this.fetchData();
                })
                .catch(error => {
                    this.$message.error('部分删除失败');
                    console.error('批量删除时出错！', error);
                });
        },
        handleDelete(index, row) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                delete_douyin_aweme_comment(row.user_id).then(() => {
                    this.$message.success('删除成功');
                    this.fetchData();
                }).catch(error => {
                    this.$message.error('删除失败');
                    console.error('删除时出错！', error);
                });
            }).catch(() => { });
        },
        handlePageChange(val) {
            this.currentPage = val;
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        resetDateFilter() {
            this.$refs.filterTable.clearFilter('date');
        },
        clearFilter() {
            this.$refs.filterTable.clearFilter();
        },
        formatter(row, column) {
            const timeFields = ['create_time', 'add_time'];
            if (timeFields.includes(column.property)) {
                const rawTime = row[column.property];
                if (!rawTime) return 'N/A';
                const time = moment.utc(rawTime);
                if (!time.isValid()) return '无效时间';
                return time.format('YYYY-MM-DD HH:mm:ss');
            }
            return row[column.property];
        },
        filterTag(value, row) {
            return row.tag === value;
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        handleSearch() {
            this.filteredTableData = this.tableData.filter(data => {
                return Object.values(data).some(value => {
                    return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
                });
            });
        }
    }
}
</script>

<style lang="stylus">
.top-actions
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px

.search-container
    margin-left: auto

.button-container
    margin-right: auto

.advanced-search-fields {
    margin-bottom: 10px;
}


</style>